import React from 'react';

import FailsafeImg from 'components/global/application/FailsafeImg';
import { imageUrlAppendStyle } from 'contexts/link_util';

import './StaffPageItem.sass';

interface Props {
    name: string;
    title: string;
    imgUrl: string;
    userUri: string;
}

const StaffPageItem: React.StatelessComponent<Props> = (props: Props) => {
    return (
        <div className="StaffPageItem-container">
            <a href={`/${props.userUri}`}>
                <FailsafeImg className="Thumbnail" src={imageUrlAppendStyle(props.imgUrl, 'user')} />
                <div>{props.name}</div>
                <div><em>{props.title}</em></div>
            </a>
        </div>
    );
};

export default StaffPageItem;



// WEBPACK FOOTER //
// ./src/components/pages/staff/StaffPageItem.tsx